"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolPencilLineIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var ToolPencilLineIcon16Light_1 = require("./ToolPencilLineIcon16Light");
var ToolPencilLineIcon16Regular_1 = require("./ToolPencilLineIcon16Regular");
var ToolPencilLineIcon16Solid_1 = require("./ToolPencilLineIcon16Solid");
var ToolPencilLineIcon20Light_1 = require("./ToolPencilLineIcon20Light");
var ToolPencilLineIcon20Regular_1 = require("./ToolPencilLineIcon20Regular");
var ToolPencilLineIcon20Solid_1 = require("./ToolPencilLineIcon20Solid");
var ToolPencilLineIcon24Regular_1 = require("./ToolPencilLineIcon24Regular");
var ToolPencilLineIcon24Solid_1 = require("./ToolPencilLineIcon24Solid");
var ToolPencilLineIcon32Regular_1 = require("./ToolPencilLineIcon32Regular");
var ToolPencilLineIcon64Regular_1 = require("./ToolPencilLineIcon64Regular");
var sizes = {
    16: {
        light: ToolPencilLineIcon16Light_1.ToolPencilLineIcon16Light,
        regular: ToolPencilLineIcon16Regular_1.ToolPencilLineIcon16Regular,
        solid: ToolPencilLineIcon16Solid_1.ToolPencilLineIcon16Solid,
    },
    20: {
        light: ToolPencilLineIcon20Light_1.ToolPencilLineIcon20Light,
        regular: ToolPencilLineIcon20Regular_1.ToolPencilLineIcon20Regular,
        solid: ToolPencilLineIcon20Solid_1.ToolPencilLineIcon20Solid,
    },
    24: {
        regular: ToolPencilLineIcon24Regular_1.ToolPencilLineIcon24Regular,
        solid: ToolPencilLineIcon24Solid_1.ToolPencilLineIcon24Solid,
    },
    32: {
        regular: ToolPencilLineIcon32Regular_1.ToolPencilLineIcon32Regular,
    },
    64: {
        regular: ToolPencilLineIcon64Regular_1.ToolPencilLineIcon64Regular,
    },
};
exports.ToolPencilLineIcon = forwardRef_1.forwardRef('ToolPencilLineIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
